import {useEffect, useState, useRef} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import {SwalAlertClass} from "core/swalClass";
import Form from "react-bootstrap/Form";
import Offcanvas from "react-bootstrap/Offcanvas";
import ValuePreviewInline from "components/ValuePreviewInline";
import BooleanPreviewInline from "components/BooleanPreviewInline";
import ValuePreview from "components/ValuePreview";
import {DeviceConfigDetails} from "site-apps/devices/DeviceConfig";
import axiApi from "ApiCaller";
import FormButton from "components/buttons/FormButton";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";
import {publishEvent} from "core/eventsConnector";
import ConditionalRender from "../../../components/ConditionalRender";

const FormShipping = ({item, items, showCanvas, setShowCanvas, setItemsShown}) => {
    const {t: _Tc} = useTranslation("choices");
    const {t: _TC} = useCustomTranslation(translations);
    const navigate = useNavigate();
    const Alert = new SwalAlertClass({confirmButtonText: _TC("button.accept")});
    const configs = useRef([]);
    const [configsShow, setConfigsShow] = useState([]);
    const [config, setConfig] = useState({...DeviceConfigDetails});
    const [carries, setCarries] = useState({
        carry_ship: true,
        carry_sensors: true,
        carry_alerts: true,
    });
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        if (!configs.current.length) {
            axiApi
                .get("/api/devices/configs/details/")
                .then((r) => {
                    configs.current = r.data.items;
                    setConfigsShow(r.data.items);
                    setConfigByItem();
                })
                .catch((error) => {
                    console.error("[FormMode] Error al obtener las configuraciones");
                    console.error(error);
                    Alert.error(_TC("message.error.title"), _TC("message.error.configs"));
                });
        } else {
            setConfigByItem();
        }
    }, []);

    const handleClose = () => setShowCanvas(false);

    const clickCancel = () => {
        setShowCanvas(false);
    };

    const onChangeCarry = (e) => {
        const {name, checked} = e.target;
        let carry = {...carries};
        carry[name] = checked;
        setCarries(carry);
    };

    const onChange = (e) => {
        let id = parseInt(e.target.value);
        if (id) {
            let chose = configs.current.filter((item) => item.id === id);
            if (chose.length) {
                setConfig({...chose[0]});
                return false;
            }
        }
        setConfig({...DeviceConfigDetails});
    };

    const onSubmit = (e) => {
        setIsLoading(true);
        e.preventDefault();
        if (!config.id) {
            Alert.warning(_TC("message.warning.title"), _TC("message.no.config.selected"));
            return false;
        }
        let itemsSelected = [];
        itemsSelected = items.current.getChosenUuids();
        let datasend = {
            config: config.id,
            chosen: itemsSelected,
            carry_ship: carries.carry_ship,
            carry_sensors: carries.carry_sensors,
            carry_alerts: carries.carry_alerts,
        };

        axiApi
            .post("/api/devices/shipping/", datasend)
            .then((r) => {
                if (r.data.status) {
                    publishEvent("reload:view:shippings");
                    Alert.success(_TC("message.success.title"), _TC("message.success.saved"));
                } else {
                    Alert.error(_TC("message.error.service"), _TC("message.error.admin"));
                }
            })
            .catch((error) => {
                console.error("[FormShipping] Error al guardar la configuración");
                console.error(error);
                if (error.response.status === 400 || error.response.status === 404) {
                    Alert.error(_TC("message.error.server"), _TC("message.error.bad.data"));
                } else {
                    Alert.error(_TC("message.error.server"), _TC("message.error.admin"));
                }
            })
            .finally(() => {
                setIsLoading(false);
                setShowCanvas(false);
            });
    };
    const setConfigByItem = () => {
        let carry = {
            carry_ship: item.carry_ship,
            carry_sensors: item.carry_sensors,
            carry_alerts: item.carry_alerts,
        };
        setCarries(carry);
        if (item.config_id && configs.current.length) {
            let chosen = configs.current.find((conf) => conf.id === item.config_id);
            if (chosen) {
                setConfig({...chosen});
                return false;
            }
        }
        setConfig({...DeviceConfigDetails});
    };

    return (
        <>
            <Offcanvas show={showCanvas} onHide={handleClose} placement="end" backdrop="false" style={{width: "700px"}}>
                <Offcanvas.Header className="preview-canvas" closeButton>
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="fa-solid fa-wrench" />
                    </div>
                    <div className="preview-title">
                        <Offcanvas.Title>{_TC("form.title.select.config")}</Offcanvas.Title>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <h4 className="text-center">
                        <span className="text-black-50">{_TC("label.uuid")}:</span> {item.uuid}
                    </h4>
                    <Form onSubmit={onSubmit} className="p-2">
                        <div className="preview-item">
                            <label>{_TC("label.profile.group")}</label>
                            <Form.Select className="mb-2" id="model" name="model" value={config.id} onChange={onChange}>
                                <option value="0">{_TC("option.select.config")}</option>
                                {configsShow.map((conf, index) => (
                                    <option key={index} value={conf.id}>
                                        {conf.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                        <ConditionalRender condition={config.id}>
                            <ValuePreviewInline label={_TC("label.model")} value={config.model} />
                            <ValuePreview label={_TC("label.name")} value={config.name} />
                            <ValuePreview label={_TC("label.description")} value={config.description} />
                            <hr className="col-12 mt-5" />
                            <div className="col-12 d-flex justify-content-between">
                                <h5>{_TC("section.measures.shipments")}</h5>
                                <div className="form-check">
                                    <label className="form-check-label" htmlFor="carry_ship">
                                        {_TC("label.send")}
                                    </label>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="carry_ship"
                                        checked={carries.carry_ship}
                                        name="carry_ship"
                                        onChange={onChangeCarry}
                                    />
                                </div>
                            </div>
                            <ValuePreviewInline label={_TC("label.model")} value={config.ships.model} />
                            <ValuePreview label={_TC("label.name")} value={config.ships.name} />
                            <ValuePreviewInline
                                label={_TC("label.interval.type")}
                                value={config.ships.interval_type ? _Tc("interval_type." + config.ships.interval_type) : ""}
                            />
                            <ValuePreviewInline label={_TC("label.sending.hour")} value={config.ships.h_start} />
                            <ValuePreviewInline label={_TC("label.minutes.between.measures")} value={config.ships.min_measure} />
                            <ValuePreviewInline label={_TC("label.number.to.send")} value={config.ships.num_pub} />
                            {config.ships.interval_type === "sim" || config.ships.interval_type === "com" ? (
                                <ValuePreviewInline label={_TC("label.number.messages")} value={config.ships.num_measure} />
                            ) : (
                                <></>
                            )}
                            {config.ships.interval_type === "com" ? (
                                <ValuePreviewInline
                                    label={_TC("label.minutes.between.measures.fl")}
                                    value={config.ships.min_measure_b}
                                />
                            ) : (
                                <></>
                            )}
                            <hr className="col-12 mt-5" />
                            <div className="col-12 d-flex justify-content-between">
                                <h5>{_TC("section.sensors")}</h5>
                                <div className="form-check">
                                    <label className="form-check-label" htmlFor="carry_sensors">
                                        {_TC("label.send")}
                                    </label>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="carry_sensors"
                                        checked={carries.carry_sensors}
                                        name="carry_sensors"
                                        onChange={onChangeCarry}
                                    />
                                </div>
                            </div>
                            <ValuePreviewInline label={_TC("label.model")} value={config.sensors.model} />
                            <ValuePreview label={_TC("label.name")} value={config.sensors.name} />
                            <ValuePreviewInline label={_TC("label.power")} value={config.sensors.power} />
                            <BooleanPreviewInline label={_TC("label.levels")} value={config.sensors.has_levels} />
                            {config.sensors.has_levels ? (
                                <>
                                    <ValuePreviewInline label={_TC("label.full")} value={config.sensors.filling_mark} />
                                    <ValuePreviewInline label={_TC("label.empty")} value={config.sensors.vacuum_mark} />
                                    <ValuePreviewInline
                                        label={_TC("label.email.empty")}
                                        value={config.sensors.email_on_emptying ? _TC("value.yes") : _TC("value.no")}
                                    />
                                    <ValuePreviewInline
                                        label={_TC("label.email.full")}
                                        value={config.sensors.email_to_filler ? _TC("value.yes") : _TC("value.no")}
                                    />
                                </>
                            ) : (
                                <></>
                            )}
                            <hr className="col-12 mt-5" />
                            <div className="col-12 d-flex justify-content-between">
                                <h5>{_TC("section.alerts")}</h5>
                                <div className="form-check">
                                    <label className="form-check-label" htmlFor="carry_alerts">
                                        {_TC("label.send")}
                                    </label>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="carry_alerts"
                                        checked={carries.carry_alerts}
                                        name="carry_alerts"
                                        onChange={onChangeCarry}
                                    />
                                </div>
                            </div>
                            <ValuePreview label={_TC("label.name")} value={config.alerts.name} />

                            {config.alerts.has_movement ? (
                                <ValuePreviewInline label={_TC("label.movement")} value={config.alerts.force} />
                            ) : (
                                <></>
                            )}
                            {config.alerts.has_not_send ? (
                                <ValuePreviewInline label={_TC("label.not.sending")} value={config.alerts.days} />
                            ) : (
                                <></>
                            )}
                            {config.alerts.has_battery ? (
                                <ValuePreviewInline label={_TC("label.battery")} value={config.alerts.level} />
                            ) : (
                                <></>
                            )}
                            {config.alerts.has_temperature ? (
                                <ValuePreviewInline label={_TC("label.temperature")} value={config.alerts.temperature} />
                            ) : (
                                <></>
                            )}
                            {config.alerts.has_signal ? (
                                <ValuePreviewInline label={_TC("label.signal")} value={config.alerts.signal} />
                            ) : (
                                <></>
                            )}
                            {config.alerts.has_out_range ? (
                                <ValuePreviewInline label={_TC("label.out.of.location")} value={config.alerts.range} />
                            ) : (
                                <></>
                            )}

                            <div className="text-end col-12 mb-4 mt-4">
                                <button type="button" className="btn btn-secondary me-4" onClick={clickCancel}>
                                    {_TC("button.cancel")}
                                </button>
                                <FormButton
                                    type="submit"
                                    className="btn btn-primary me-3"
                                    variant="primary"
                                    label={_TC("button.save")}
                                    isProcessing={isLoading}>
                                    {_TC("button.save")}
                                </FormButton>
                            </div>
                        </ConditionalRender>
                    </Form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default FormShipping;
